// Cart storage service using localStorage
const CART_STORAGE_KEY = 'mmk_cart';

// Get cart from localStorage
export const getCart = () => {
  try {
    const cart = localStorage.getItem(CART_STORAGE_KEY);
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error getting cart from localStorage:', error);
    return [];
  }
};

// Save cart to localStorage
export const saveCart = (cart) => {
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
    return true;
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
    return false;
  }
};

// Add item to cart
export const addToCart = (item) => {
  const cart = getCart();
  const existingItemIndex = cart.findIndex(cartItem => cartItem.sku === item.sku);
  
  if (existingItemIndex > -1) {
    // Update quantity if item already exists
    cart[existingItemIndex].quantity += item.quantity;
  } else {
    // Add new item to cart
    cart.push(item);
  }
  
  return saveCart(cart);
};

// Remove item from cart
export const removeFromCart = (sku) => {
  const cart = getCart();
  const filteredCart = cart.filter(item => item.sku !== sku);
  return saveCart(filteredCart);
};

// Update item quantity in cart
export const updateCartItemQuantity = (sku, quantity) => {
  const cart = getCart();
  const itemIndex = cart.findIndex(item => item.sku === sku);
  
  if (itemIndex > -1) {
    if (quantity <= 0) {
      return removeFromCart(sku);
    } else {
      cart[itemIndex].quantity = quantity;
      return saveCart(cart);
    }
  }
  
  return false;
};

// Clear entire cart
export const clearCart = () => {
  return saveCart([]);
};

// Get cart item count (total quantity of all items)
export const getCartItemCount = () => {
  const cart = getCart();
  return cart.reduce((total, item) => total + item.quantity, 0);
};

// Get cart total price
export const getCartTotal = () => {
  const cart = getCart();
  return cart.reduce((total, item) => {
    const price = parseFloat(item.price.toString().replace(/[^\d.]/g, ''));
    return total + (price * item.quantity);
  }, 0);
};

// Get cart total weight (in kg)
export const getCartTotalWeight = () => {
  const cart = getCart();
  return cart.reduce((total, item) => {
    const weight = parseFloat(item.weight) || 0;
    return total + (weight * item.quantity);
  }, 0);
};
